module.exports = __webpack_public_path__ + "img/logo.5cfb6a03.png";